import {GET_ADDED_SPONSORS } from '../../actiontypes'

export const AddSponsorReducer = (addedsponsor) => {
    return (dispatch) => {
            dispatch({ type: GET_ADDED_SPONSORS, payload: addedsponsor});
    }      
};